import { injectBaseConstantMethods } from "./BaseConstants";

export const UserRoleType = {
    ADMIN: "ADMIN",
    USER: "USER"
};

const displayTextKeys = {
    [UserRoleType.ADMIN]: "Admin",
    [UserRoleType.USER]: "User"
};

const labelClass = {
    [UserRoleType.SuperAdmin]: "success"
};

export default injectBaseConstantMethods(UserRoleType, displayTextKeys, labelClass);
